'use client'
import { Viewport } from 'next'
//import useClient from 'next';
import { Inter } from 'next/font/google'
import './globals.css'
import { NextUIProvider } from "@nextui-org/system"
import RiskifiedBeacon from '@/components/riskified'
const inter = Inter({ subsets: ['latin'] })
import ReduxProvider from "@/redux/provider";
import { AuthProvider } from './AuthProvider';
import Image from 'next/image';
import { X } from 'lucide-react';
//import { feathersClient } from '@/components/connection/page'
//import Head from 'next/head';


import { GoogleAnalytics } from '@next/third-parties/google';
import PWAStatusChecker from './PWAStatusChecker';
import OneSignalComponent from './OneSignalComponent'
import MailchimpPopup from './MailchimpPopup';
// import CustomPWAInstall from './CustomPwaInstallModal';

// import PWAInstall1 from './PWAInstall1';

import GTM from './GTM'
import { useEffect } from 'react'

// import PwaInstall from './PwaInstall'
// import PwaInstall from './PwaInstall';

// export const metadata: Metadata = {
//   manifest:"/manifest.json",
//   title: 'Karma Tickets - Your Trusted Source for Event & Sports Ticket Booking in Canada',
//   description: 'Find tickets for concerts, sports, and events in Canada. Fast, secure booking with exclusive deals at Karma Tickets. Get yours now!',
//   icons:{
//     icon: '/Logo.png',
//   }
// }




export const viewport: Viewport = {
  themeColor: "#397bea",
  width: 'device-width',
  initialScale: 1,
  maximumScale: 1,
  userScalable: false,
};

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
    useEffect(() => {
      localStorage.removeItem('pwa-installed');
    const el = document.getElementById('pwa-install-element');
    if (el) {
      el.classList.add('hidden'); 
    }
    let data = localStorage.getItem('pwa-installed');
    if (data === 'true') {
      const modal = document.getElementById("promoModal");
      if (modal) {  
        modal.style.display = "none";
        //localStorage.removeItem('pwa-installed');
      }
    }
    
    
  }, []);
  
  return (
    <AuthProvider>
      <html lang="en">
        <head>


          <script type="module" src="/pwa-install-unminified.js"></script>

        </head>

        <body className={inter.className}>
          <noscript>
            <iframe
              src={`https://www.googletagmanager.com/ns.html?id=GTM-P99KX6PD`}
              height="0"
              width="0"
              style={{ display: 'none', visibility: 'hidden' }}
            ></iframe>
          </noscript>
          <NextUIProvider>
            <RiskifiedBeacon />
            <GoogleAnalytics gaId='G-0VJR84XEZF' />
            <ReduxProvider>
              <GTM />
              <PWAStatusChecker >
                {/* <script type="module" src="/pwa-install-unminified.js"></script> */}
                <pwa-install
                  id="pwa-install-element"
                  manifest-url="manifest.json"
                  install-description="INSTALL OUR APP! Tap on ‘Add to Home Screen’ below and follow the instructions."
                  name="KARMA APP"
                  description="SPECIALIZING IN GAME DAY DEALS">
                </pwa-install>
                <div>
                  <div
                    id="promoModal"
                    className="modal fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60"
                  >
                    <div className="modal-content bg-[#f47920] p-6 rounded-xl text-center max-w-md w-full relative shadow-2xl border border-gray-300">
                      <button
                        className="close absolute top-2 right-2 text-gray-800 bg-white border border-gray-300 rounded-full w-6 h-6 flex items-center justify-center font-bold"
                        onClick={() => {
                          const modal = document.getElementById("promoModal");
                          if (modal) {
                            modal.style.display = "none";
                          }
                        }}
                      >
                        &times;
                      </button>

                      <div className="hero-row flex flex-row items-center gap-4 justify-center">
                        <img src="/Logo.png" alt="Karma Logo" className="w-24 h-auto" />
                        <h1 className="text-2xl font-extrabold text-[#003366] leading-snug tracking-wide uppercase text-left">
                          Welcome to<br />our website!
                        </h1>
                      </div>


                      <h2 className="mt-4 text-lg font-bold text-white">
                        Download our new app<br />
                        to receive updates on:
                      </h2>

                      <h3 className="text-[#003366] mt-4 font-bold leading-relaxed text-base">
                        Free Ticket Giveaways<br />
                        Game Day Deals<br />
                        Discount Code Offers<br />
                        Concert Price Drops<br />
                        New Razz Launches
                      </h3>

                      <button
                        className="bg-[#00b9f1] hover:bg-[#00a8de] text-white font-semibold py-2 px-6 rounded-full mt-4 transition duration-300"
                        onClick={() => {
                          const modal = document.getElementById("promoModal");
                          if (modal) modal.style.display = "none";
                          

                          const script = document.createElement('script');
                          script.type = 'module';
                          script.src = '/pwa-install-unminified.js';


                          const pwaInstall = document.getElementById("pwa-install-element");


                          if (pwaInstall) {
                             pwaInstall.classList.remove("hidden"); 
                              localStorage.setItem('pwa-installed', 'true');
                            const interval = setInterval(() => {
                              if (typeof (pwaInstall as any).showDialog === "function") {
                                clearInterval(interval);
                                (pwaInstall as any).showDialog();
                              }
                            }, 100);
                            setTimeout(() => clearInterval(interval), 100);
                          }
                        }}
                      >
                        Install App
                      </button>

                      <p className="text-gray-900 text-xs mt-4">
                        Karma Tickets is a Toronto based company
                      </p>
                    </div>
                  </div>
                </div>




                {/* <PWAInstall1 />

                 {/* <CustomPWAInstall />  */}

                <OneSignalComponent />
                <MailchimpPopup />


                {children}
              </PWAStatusChecker >


            </ReduxProvider>
          </NextUIProvider>



        </body>
      </html>
    </AuthProvider>
  )
}
